import { Component, EventEmitter, Output } from '@angular/core';
import { ExampleHeader } from './example-header/example-header.component';

@Component({
  selector: 'app-calendar-date',
  templateUrl: './calendar-date.component.html',
  styleUrls: ['./calendar-date.component.scss'],
})
export class CalendarDateComponent {
  @Output() selectedDate = new EventEmitter();
  minDate: Date = new Date();
  date: Date = new Date();
  isDateValid: boolean = false;
  exampleHeader = ExampleHeader;
  calendarToggle() {
    this.selectedDate.emit(this.date);
  }
}
